import { useEffect, useState } from "react";
import Logo from "./components/Logo";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function LoginPage({ onLogin }) {
  const [status, setStatus] = useState("idle"); // idle | loading | error | not_invited
  const [errorEmail, setErrorEmail] = useState("");

  // Handle redirect back from Google OAuth
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const auth  = params.get("auth");
    const token = params.get("token");
    const email = params.get("email");

    if (auth === "success" && token) {
      localStorage.setItem("lh_token", token);
      onLogin(token);
    } else if (auth === "not_invited") {
      setStatus("not_invited");
      setErrorEmail(email || "");
    } else if (auth === "error") {
      setStatus("error");
    }

    if (auth || token || email) {
      const cleanUrl = `${window.location.origin}${window.location.pathname}`;
      window.history.replaceState({}, "", cleanUrl);
    }
  }, [onLogin]);

  const handleGoogleLogin = () => {
    setStatus("loading");
    window.location.href = `${API}/api/auth/google`;
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f8fafc",
      fontFamily: "'DM Sans', -apple-system, sans-serif",
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <div style={{
        background: "white", borderRadius: 16,
        border: "1px solid #e2e8f0", padding: "48px 40px",
        width: "100%", maxWidth: 400, textAlign: "center",
        boxShadow: "0 4px 24px rgba(15,23,42,0.08)",
      }}>
        {/* Logo */}
        <div className="login-brand">
          <Logo className="login-brand-logo" alt="WaveProspect" />
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>Welcome back</h1>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 32 }}>Sign in to access your leads pipeline</p>

        {/* Error states */}
        {status === "not_invited" && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "12px 14px", marginBottom: 20, fontSize: 13, color: "#dc2626", textAlign: "left" }}>
            <strong>Access denied</strong><br />
            {errorEmail} is not on the invite list. Contact the admin to get access.
          </div>
        )}
        {status === "error" && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "12px 14px", marginBottom: 20, fontSize: 13, color: "#dc2626" }}>
            Something went wrong. Please try again.
          </div>
        )}

        {/* Google sign in button */}
        <button
          onClick={handleGoogleLogin}
          disabled={status === "loading"}
          style={{
            width: "100%", display: "flex", alignItems: "center", justifyContent: "center",
            gap: 12, padding: "12px 20px", border: "1px solid #e2e8f0", borderRadius: 9,
            background: "white", fontSize: 15, fontWeight: 600, color: "#0f172a",
            cursor: status === "loading" ? "not-allowed" : "pointer",
            opacity: status === "loading" ? 0.7 : 1,
            transition: "all 0.15s",
          }}
          onMouseEnter={e => { if (status !== "loading") { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)"; }}}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}
        >
          {status === "loading" ? (
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" style={{ animation: "spin 0.8s linear infinite" }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeOpacity="0.3"/><path d="M21 12a9 9 0 00-9-9"/></svg>
              Signing in...
            </span>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </>
          )}
        </button>

        <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 24, lineHeight: 1.6 }}>
          This is an invite-only tool.<br />
          Access is controlled by the admin.
        </p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}






